var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.439745 1.21599C0.721678 0.934407 1.10385 0.776245 1.50232 0.776245C1.90078 0.776245 2.28296 0.934407 2.56489 1.21599L8.01809 6.66919L13.4713 1.21599C13.7563 0.950386 14.1333 0.80579 14.5229 0.812663C14.9124 0.819537 15.2841 0.977342 15.5596 1.25283C15.8351 1.52833 15.9929 1.9 15.9998 2.28954C16.0066 2.67909 15.862 3.05609 15.5964 3.34113L9.08066 9.8569C8.79873 10.1385 8.41656 10.2966 8.01809 10.2966C7.61963 10.2966 7.23745 10.1385 6.95552 9.8569L0.439745 3.34113C0.158162 3.0592 1.1726e-08 2.67703 9.26788e-09 2.27856C6.80972e-09 1.8801 0.158162 1.49792 0.439745 1.21599Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon--arrow-down.fbde6acd5c73947e625f1a562eb6af1f.svg";
export { ForwardRef as ReactComponent };